import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button, Field, Input, Text } from '@datanomik/core-ui';

interface SsoFormValues {
  loginDomain: string;
}

interface SsoFormProps {
  busy: boolean;
  defaultDomain?: string;
  onSubmit: (loginDomain: string) => void;
}

export function SsoForm({ busy, defaultDomain = '', onSubmit }: SsoFormProps) {
  const { t } = useTranslation();
  const { register, handleSubmit, formState } = useForm<SsoFormValues>({
    defaultValues: { loginDomain: defaultDomain },
  });

  return (
    <form
      onSubmit={handleSubmit(({ loginDomain }) => onSubmit(loginDomain.trim()))}
      noValidate
      className="flex flex-col gap-4"
    >
      <Field label={t('Company name')} required error={formState.errors.loginDomain?.message}>
        <Input
          autoComplete="off"
          placeholder={t('Company name')}
          endAdornment={(
            <Text variant="body-sm" tone="muted" as="span" className="whitespace-nowrap">
              {t('.datanomik.com')}
            </Text>
          )}
          {...register('loginDomain', { required: t('Company name is required') })}
        />
      </Field>

      <Button type="submit" className="w-full" loading={busy}>
        {t('Continue')}
      </Button>
    </form>
  );
}
